import * as Sentry from '@sentry/react';

import RTKQueryError from '../RTKQueryError';

export const fusionGlobalReportStatuses = [400, 401, 404, 410];
export default class FusionQueryError extends RTKQueryError {
  /**
   * @param {object} result The response returned from an RTKQuery fetchBaseQuery. See type FetchBaseQueryResult at FetchBaseQueryResult https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#signature
   * @param {string|object} args The arguments provided to the query. See FetchBaseQueryArgs https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#signature
   * @param {*} rtk The RTK Query api object containing the dispatcher, getState and more. See interface BaseQueryApi https://redux-toolkit.js.org/rtk-query/api/createApi#basequery-function-signature
   */
  constructor(result, arg) {
    const { endpoint, type } = result.meta || {};
    super(result, arg, endpoint, type);
    this.name = 'FusionQueryError';
    this.globalReportStatuses = fusionGlobalReportStatuses;

    if (result.error.status === 'PARSING_ERROR') {
      // parsing error will occur if the server responds with HTML, as Fusion sometimes does
      this.status = result.error.originalStatus;
    }

    this.message = `${this.endpoint} ${this.type} failed with status ${this.status}`;
  }

  get shouldReport() {
    return !this.globalReportStatuses.includes(this.status);
  }

  get shouldRedirect() {
    return [401].includes(this.status);
  }

  get redirectUrl() {
    return this.data?.redirectUrl || this.data?.redirect_url;
  }

  redirect() {
    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    } else {
      Sentry.captureMessage(`No redirect url from ${this.url}`, (scope) => {
        scope.setLevel('fatal');
        scope.setExtra('url', this.url);
        scope.setExtra('response', this.data);
      });
    }
  }
}
